import styled from 'styled-components';

export const MetricsWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
`;

export const MetricSingle = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.baseGreen};
  font-family: "NeueMachina";
  font-size: 8rem;
  font-weight: 800;
`;

export const MetricMedium = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.selection};
  font-family: "NeueMachina";
  font-size: 4.5rem;
  font-weight: 800;
`;

export const MetricsContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const MetricsWidget = styled.div`
  width: 50%;
  aspect-ratio: 16 / 9;
  gap: 1rem;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
`;

export const MetricsTitle = styled.div`
  color: white;
  font-family: "NeueMachina";
  font-size: 1rem;
  font-weight: 800;
`;

export const MetricsWidgetContent = styled.div`
  width: 100%;
  flex: 1;
`;
